import React, {useState} from 'react';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {OutlinedInput,TextField} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

function InputPassword(props) {

  const {
    item,
    onChange,
  } = props;

  const {
    id='password',
    type='password',
    label='Password',
    labelWidth=70,
    value,
    error,
    required = true,
  } = item;

  const [showPassword, setShowPassword] = useState(true)
  return (
    <FormControl
      variant="outlined"
      fullWidth
      error={error ? error : false}
    >
      <InputLabel htmlFor={id||label} error={error}>{label}</InputLabel>
      <OutlinedInput
        id={id||label}
        variant={'standard'}
        type={showPassword ? type : 'text'}
        value={value}
        margin="normal"
        required={required}
        fullWidth
        error={error}
        inputProps={{maxLength:item?.maxLength}}
        onChange={(event) =>
          onChange(event.target.value, id)
        }
        labelWidth={labelWidth}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <Visibility/> : <VisibilityOff/>}
            </IconButton>
          </InputAdornment>}
      />
      {/*error message*/}
      <p className='error-class'>{error}</p>
    </FormControl>
  );
}

export default InputPassword;
